import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import useIntegration from 'api/useIntegration';
import { useDeveloperSettingsEnabled } from 'hooks/useDeveloperSettingsEnabled';
import { capitalizeFirstLetter } from 'utils/formattingUtil';

import { ESettingsState } from 'components/Settings/Settings.types';
import SharedSettingsView, { SharedSettingsTab } from 'components/Settings/SharedSettingsView';

const getDefaultPortalSettingsTab = (isDeveloperSettingsEnabled: boolean): ESettingsState => {
  if (isDeveloperSettingsEnabled) {
    return ESettingsState.DEVELOPER_SETTINGS;
  }
  return ESettingsState.PORTAL;
};

const SettingsView = () => {
  const { publisherId } = useParams();
  const { getIntegration } = useIntegration(publisherId);
  const isDeveloperSettingsEnabled = useDeveloperSettingsEnabled();

  const tabs = useMemo((): SharedSettingsTab[] => {
    const settingsTabs: SharedSettingsTab[] = [];

    if (isDeveloperSettingsEnabled) {
      settingsTabs.push({
        label: 'Developer Settings',
        value: ESettingsState.DEVELOPER_SETTINGS
      });
    } else {
      settingsTabs.push({
        label: capitalizeFirstLetter(ESettingsState.PORTAL),
        value: ESettingsState.PORTAL
      });
    }

    settingsTabs.push({
      label: capitalizeFirstLetter(ESettingsState.USERS),
      value: ESettingsState.USERS
    });

    if (!isDeveloperSettingsEnabled) {
      settingsTabs.push({
        label: capitalizeFirstLetter(ESettingsState.INTEGRATION),
        value: ESettingsState.INTEGRATION
      });
    }

    settingsTabs.push(
      { label: 'Authentication', value: ESettingsState.PLAYER_AUTH },
      { label: 'Events Center', value: ESettingsState.EVENTS }
    );

    return settingsTabs;
  }, [isDeveloperSettingsEnabled]);

  const defaultTab = getDefaultPortalSettingsTab(isDeveloperSettingsEnabled);

  return (
    <SharedSettingsView
      tabs={tabs}
      defaultTab={defaultTab}
      headline="Portal settings"
      basePath="portal"
      onTabChange={() => getIntegration.refetch()}
    />
  );
};

export default SettingsView;
